import * as React from "react";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import { IDraftWorkSearchQuery } from "../types/IDraftWorkSearchQuery";
import { IDraftWorkSearchResult } from "../types/IDraftWorkSearchResult";
import { setDataSource } from "../../redux/reducers/MembersPortalReducer";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { DataSource } from "../../repertoire/types/DataSource";
import { IMemberWorkSearchResult } from "../types/IMemberWorkSearchResult";
import { MemberPortalSearchTypeItem } from "../../redux/types/MemberPortalSearchTypeItem";
import { FormatFields } from "../../redux/types/FormatFields";
import { IMyPackagesResult } from "../../repertoire/types/IMyPackagesResult";
import MemberWorksPage from "../memberWorks/MemberWorksPage";
import { SEARCH_VIEW_DRAFT_WORKS } from "../Consts";
import { IMembersPortalPathInfo } from "../types/IMembersPortalPathInfo";


export interface IDraftWorksPageProps {
    draftWorksPageData: IMembersPortalComponentDataItem;
    searchViewData: IMembersPortalComponentDataItem;
    searchResultsTableData: IMembersPortalComponentDataItem;
    searchDraftWorks?: (query: IDraftWorkSearchQuery) => void;
    draftWorkSearchResults: IDraftWorkSearchResult[];
    memberWorkSearchResults?: IMemberWorkSearchResult[];
    searchSuccessful: boolean;
    draftWorksMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem;
    lookupValues: ILookupDictionary;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location) => void;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    getDraftWorkDetails: (dataSource: string, workID: number, lookupValues: ILookupDictionary, draftWorkMaintenanceDataViewData: IMembersPortalComponentDataItem, formats?: FormatFields[]) => void;
    addNewDraftWorks: (lookups: ILookupDictionary, currentUserNameNumber?: string, isNew?: boolean, draftWorksMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem, formats?: FormatFields[]) => void;
    sortSearchResults: (name: string, results: any) => void;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
    disabled?: boolean;
    roles?: string[];
    saveRoles?: (roles: string[]) => void;
    setDataSource: typeof setDataSource;
    dataSource: string;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    memberPortalSearchType: MemberPortalSearchTypeItem;
    currentUserNameNumber?: string;
    expandWorkResult?: (workResult: number) => void;
    expandedWorkResults?: number[];
    expandAllResults: () => void;
    expandAll: boolean;
    addToPackages?: (userName: string, entityType: string, entityIds: number[]) => IMyPackagesResult;
    customer?: string;
}

const DraftWorksPage = (props: IDraftWorksPageProps) => {


        const currentDataSource = DataSource.Intray;

        React.useEffect(() => {
            if (props.dataSource !== currentDataSource) {
            props.setDataSource(currentDataSource);
            }
        }, [props.dataSource]);

        return ( <MemberWorksPage 
            memberWorksPageData={ props.draftWorksPageData}
            searchViewData={ props.searchViewData}
            searchResultsTableData={ props.searchResultsTableData}
            searchDraftWorks={ props.searchDraftWorks}
            memberWorkSearchResults={ props.draftWorkSearchResults}
            searchSuccessful={ props.searchSuccessful}
            memberWorksMaintenanceGeneralDataViewData={ props.draftWorksMaintenanceGeneralDataViewData}
            lookupValues={ props.lookupValues}
            indexOfFirstResult={ props.indexOfFirstResult}
            indexOfLastResult={ props.indexOfLastResult}
            resultsPerPage={ props.resultsPerPage}
            currentPage={ props.currentPage}
            resetPagination={ props.resetPagination}
            updatePagination={ props.updatePagination}
            getMemberWorkDetails={ props.getDraftWorkDetails}
            addNewDraftWorks={ props.addNewDraftWorks}
            sortSearchResults={ props.sortSearchResults}
            defaultActiveAccordions={ props.defaultActiveAccordions}
            allResultsPerPage={ props.allResultsPerPage}
            updateUserPreferences={ props.updateUserPreferences}
            disabled={ props.disabled}
            roles={ props.roles}
            saveRoles={ props.saveRoles}
            setDataSource={ props.setDataSource}
            dataSource={ currentDataSource }
            activeTab={props.activeTab}
            loadMembersPortalFromPath={props.loadMembersPortalFromPath }
            tabs={ props.tabs}
            memberPortalSearchType={ props.memberPortalSearchType}
            expandWorkResult={ props.expandWorkResult}
            expandedWorkResults={ props.expandedWorkResults}
            expandAllResults={ props.expandAllResults}
            expandAll={ props.expandAll}
            currentUserNameNumber={ props.currentUserNameNumber}
            componentInstance= {SEARCH_VIEW_DRAFT_WORKS}
            customer={props.customer}
        />
    );

}

export default DraftWorksPage;
